import { Modal, Button, Alert } from "antd";
import api from "ApiClient";
import { Trans, useTranslation } from "react-i18next";
import { useState } from "react";
import { ApiURL, globalLogOut } from "utils/Actions";
import { API_RESPONSE_STATUS } from "utils/Constants";
import { StaffUserType } from "utils/Types";
import { showErrorNotification } from "utils/hooks/handleNotification";

interface ConfirmRoleProps {
  open: boolean;
  onCancel: () => void;
  staff: StaffUserType;
  selectedRoles: string[];
}
export default function ConfirmRole({ open, onCancel, staff, selectedRoles }: ConfirmRoleProps) {
  const { t } = useTranslation();
  const [errors, setErrors] = useState<string[] | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async () => {
    setIsSubmitting(true);
    try {
      const result = await api.put(ApiURL.updateRole, {
        email: staff.email,
        seqNum: staff.seqNum,
        roles: selectedRoles
      });
      if (result.data.status === API_RESPONSE_STATUS.SUCCESS) {
        globalLogOut();
      } else {
        showErrorNotification({ message: "Unable to save changes" });
        setErrors(result.data.errors);
        throw new Error(result.data.errors);
      }
    } catch (error) {
      console.error({ error });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={t("confirmRole.heading")}
      closable={!isSubmitting}
      maskClosable={false}
      footer={[
        <Button
          key="update"
          type="primary"
          onClick={handleSave}
          disabled={isSubmitting}
          loading={isSubmitting}
        >
          {t("confirmRole.confirmCTA")}
        </Button>
      ]}
    >
      {errors && (
        <Alert
          message={errors.join(" ")}
          type="error"
          closable
          showIcon
          style={{ width: "100%", marginBottom: 24 }}
        />
      )}
      <Trans>{t("confirmRole.description")}</Trans>
    </Modal>
  );
}
